import { useMutation, useQueryClient } from '@tanstack/react-query'

import { dataOrThrow, type PostPortalOrderRefillBody } from '@snootsvet/shared/portal'

import { usePortalApi } from '@/customer/hooks/use-api'
import { orderRefillsQueryKey } from '@/customer/hooks/use-list-order-refills'
import { captureEvent } from '@/customer/lib/posthog'

/** Creates a pending order for an eligible prescription refill. */
export function useCreateOrderRefill() {
  const api = usePortalApi()
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: PostPortalOrderRefillBody) =>
      dataOrThrow(await api.post('/orders/refill', { body })),
    onSuccess: ({ order }, { treatmentId }) => {
      queryClient.invalidateQueries({ queryKey: orderRefillsQueryKey })
      queryClient.invalidateQueries({ queryKey: ['portal-orders'] })
      captureEvent('refill_requested', {
        patient_id: order.patientId,
        treatment_id: treatmentId,
        clinic_id: order.clinic.id,
      })
    },
  })
}
